module.exports = __webpack_public_path__ + "img/father-andrew-white.80b8881c.png";